import { render, staticRenderFns } from "./TotalAmountView.vue?vue&type=template&id=724c479a&scoped=true"
import script from "./TotalAmountView.vue?vue&type=script&lang=js"
export * from "./TotalAmountView.vue?vue&type=script&lang=js"
import style0 from "./TotalAmountView.vue?vue&type=style&index=0&id=724c479a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c479a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724c479a')) {
      api.createRecord('724c479a', component.options)
    } else {
      api.reload('724c479a', component.options)
    }
    module.hot.accept("./TotalAmountView.vue?vue&type=template&id=724c479a&scoped=true", function () {
      api.rerender('724c479a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/TotalAmountView.vue"
export default component.exports